
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailData } from "./types";

interface TestEmailTabsProps {
  emails: EmailData[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const TestEmailTabs = ({ emails, activeTab, onTabChange }: TestEmailTabsProps) => {
  const confirmSignupCount = emails.filter(e => e.type === 'confirm_signup').length;
  const resetPasswordCount = emails.filter(e => e.type === 'reset_password').length;
  const smtpTestCount = emails.filter(e => e.type === 'smtp_test').length;

  return (
    <Tabs value={activeTab} onValueChange={onTabChange}>
      <TabsList className="mb-4">
        <TabsTrigger value="all">
          All ({emails.length})
        </TabsTrigger>
        <TabsTrigger value="confirm_signup">
          Verification ({confirmSignupCount})
        </TabsTrigger>
        <TabsTrigger value="reset_password">
          Reset Password ({resetPasswordCount})
        </TabsTrigger>
        <TabsTrigger value="smtp_test">
          SMTP Tests ({smtpTestCount})
        </TabsTrigger>
        <TabsTrigger value="smtp_config">
          SMTP Config
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default TestEmailTabs;
